module.exports = __webpack_public_path__ + "static/media/impressum.4f8a8fe3.md";